import { Layout } from "@/components/layout/Layout";
import { SEOHead } from "@/components/seo/SEOHead";
import { Breadcrumbs } from "@/components/seo/Breadcrumbs";
import { WebPageSchema } from "@/components/seo/JsonLd";

export default function Terms() {
  return (
    <Layout>
      <SEOHead title="Terms of Service" description="Terms of service for Redline Inflatables rentals. Rental agreement, liability, and conditions of use." canonical="/terms" pageUrl="/terms" />
      <WebPageSchema
        name="Terms of Service"
        description="Terms of service for Redline Inflatables rentals. Rental agreement, liability, and conditions of use."
        url="/terms"
      />
      <Breadcrumbs items={[{ name: "Terms of Service", href: "/terms" }]} />

      <section className="py-12 lg:py-16">
        <div className="section-container">
          <div className="mx-auto max-w-3xl prose prose-slate">
            <h1>Terms of Service</h1>
            <p className="lead">[Placeholder: Last updated: January 2024]</p>
            
            <h2>Rental Agreement</h2>
            <p>[Placeholder: By booking with Redline Inflatables, you agree to the following terms and conditions.]</p>
            
            <h2>Booking & Payment</h2>
            <p>[Placeholder: Deposit requirements, payment terms, and confirmation process.]</p>
            
            <h2>Customer Responsibilities</h2>
            <p>[Placeholder: Supervision requirements, site preparation, access for delivery, and care of equipment.]</p>
            
            <h2>Safety Requirements</h2>
            <p>[Placeholder: Safety rules, supervision requirements, and prohibited activities.]</p>
            
            <h2>Liability & Insurance</h2>
            <p>[Placeholder: Liability limitations, damage responsibility, and insurance requirements.]</p>
            
            <h2>Weather Policy</h2>
            <p>[Placeholder: Conditions under which rentals may be cancelled or rescheduled due to weather.]</p>
            
            <h2>Contact</h2>
            <p>[Placeholder: Contact information for questions about terms.]</p>
          </div>
        </div>
      </section>
    </Layout>
  );
}
